import LegalLayout from "./LegalLayout";
import { CheckCircle, ShieldCheck, LockKey } from "@phosphor-icons/react";

export default function DPIA() {
  return (
    <LegalLayout eyebrow="Legal · DPIA" title="Data Protection Impact Assessment (DPIA) Summary" effective="Conducted July 2026 by Gillian Berry (Data Controller)">
      <section>
        <h2 className="font-display text-xl mb-2">Nature of Processing</h2>
        <p>Collection and processing of financial and compliance data for expense management and grant reporting.</p>
      </section>

      <section>
        <h2 className="font-display text-xl mb-2">Risk Assessment</h2>
        <div className="grid sm:grid-cols-2 gap-4 mt-3">
          <div className="rounded-xl border border-white/10 bg-black/25 p-5">
            <div className="flex items-center gap-2 text-[#00A86B]"><LockKey weight="fill" size={16}/> Breach risk</div>
            <p className="text-sm text-white/70 mt-2">Mitigated by EU-region, GDPR-compliant hosting, encryption, MFA, and audit logs.</p>
          </div>
          <div className="rounded-xl border border-white/10 bg-black/25 p-5">
            <div className="flex items-center gap-2 text-[#FFB020]"><ShieldCheck weight="fill" size={16}/> Inaccurate data</div>
            <p className="text-sm text-white/70 mt-2">User verification + logging.</p>
          </div>
          <div className="rounded-xl border border-white/10 bg-black/25 p-5 sm:col-span-2">
            <div className="flex items-center gap-2 text-[#00A86B]"><CheckCircle weight="fill" size={16}/> Residual risk</div>
            <p className="text-sm text-white/70 mt-2">Low.</p>
          </div>
        </div>
      </section>

      <section>
        <h2 className="font-display text-xl mb-2">Conclusion</h2>
        <p>Processing is lawful, necessary, and proportionate. Full DPIA available on request.</p>
      </section>

      <section>
        <p className="text-sm text-white/60">Contact the Data Controller for the full DPIA document: <a className="text-[#FFB020] underline" href="mailto:gillian@percen360.com">gillian@percen360.com</a></p>
      </section>
    </LegalLayout>
  );
}
